if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.minQuantityToAdd = JSON.parse(this.dataset.minQuantityToAdd)
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        if(this.minQuantityToAdd) {
          this.submitButton.setAttribute('disabled','')
          var checkedInput = 'subscribe'

          // check the frequency to change the minimum quantity
          this.listenToFrequency(checkedInput);

          // Calling the function on loading
          this.handleMinQuantityToAdd(checkedInput, this.minQuantityToAdd)

          var subscriptionOptionsInput = document.querySelectorAll('subscribe-option input')
          subscriptionOptionsInput.forEach(input => {
            input.addEventListener('change', (e)=>{
              if (input.checked) {
                if (input.value == "subscribe") {
                  console.log('subscription input has been checked')
                  var checkedInput = 'subscribe'
                  // Get the selected value minimum qty from the frequency
                  const frequency = document.querySelector(`select[name="selling_plan"]`)
                  const freqMinimumQty = frequency.options[ frequency.selectedIndex ].getAttribute('data-minimum-qty');
                  this.minQuantityToAdd = parseInt(freqMinimumQty);
                  // Call the Handle Min Quantity Function
                  this.handleMinQuantityToAdd(checkedInput, this.minQuantityToAdd)
                  // Call Offer Block Update Function
                  this.updateOfferBarData(freqMinimumQty);
                }else{
                  console.log('OTP input has been checked')
                  var checkedInput = 'otp'
                  this.minQuantityToAdd = 1
                  this.handleMinQuantityToAdd(checkedInput, this.minQuantityToAdd)
                }
              }
            })
          });
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);

        this.updateQuantityInputs()
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
            // this.updateOfferBar(html);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      updateQuantityInputs(){
        // Custom Code to make sure that all the QTY inputs to be set to Min value
        if (this.querySelectorAll('.product-form__quantity.product-form__variant-quantity')) {
          this.quantityForms = this.querySelectorAll('.product-form__quantity.product-form__variant-quantity');
          this.quantityForms.forEach(qtyForm => {
            const qtyInput = qtyForm.querySelector('.quantity__input')
            qtyInput.value = qtyInput.getAttribute('data-min')
          });
        }
      }

      updateOfferBar(html){
        // Updated Offer Block
        const offerBlockUpdate = html.querySelector('.product__offer-block')
        console.log('offerBlockUpdate: ', offerBlockUpdate)
        // Current Offer Block
        const currentOfferBlock = document.querySelector('.product__offer-block')
        console.log('currentOfferBlock: ', currentOfferBlock)
        // Replacing content
        if (currentOfferBlock) {
          currentOfferBlock.innerHTML = offerBlockUpdate.innerHTML
        }
      }
      handleMinQuantityToAdd(checkedInput, min){
        let changeEvent = new Event('change');
        /*
          Every variant is sold one time and on subscription, so the same
          quantity inputs drive both modes.
        */
        var QTYs = document.querySelectorAll('.option_variant .quantity__input')
        /*
          This is for handling the issue that make the Minus quantity button
          to be disabled event if it's working.
        */
        QTYs.forEach(input => {
          input.dispatchEvent(changeEvent);
        });
        var targetNumber = min
        let enableButton = this.checkAtc(QTYs, targetNumber)
        this.updateAtc(enableButton)
        // let enableButton = false;
        QTYs.forEach(QTY => {
          QTY.addEventListener('change', (e)=>{
            /*
              total >= targetNumber ? enableButton = true :  enableButton = false
              setTimeout(() => {
                !enableButton ? this.submitButton.setAttribute('disabled', 'disabled') : this.submitButton.removeAttribute('disabled')
              }, 500);
            */

            enableButton = this.checkAtc(QTYs, targetNumber)
            this.updateAtc(enableButton)
          })
        });
      }
      
      checkAtc(QTYs, targetNumber){
        var total = 0
        QTYs.forEach(QTY => {total = total + parseInt(QTY.value)});
        if (total >= targetNumber) {
          return true
        }else{
          return false
        }
      }

      updateAtc(enable){
        setTimeout(() => {
          !enable ? this.submitButton.setAttribute('disabled', 'disabled') : this.submitButton.removeAttribute('disabled')
        }, 500);
      }

      listenToFrequency(checkedInput){
        const frequency = document.querySelector(`select[name="selling_plan"]`)
        const subscriptionBoxTitle = document.querySelector('.option-box__sub [data-subscription-title]')
        const subscriptionBoxTitleLabel = subscriptionBoxTitle.getAttribute('data-subscription-title')
        frequency.addEventListener('change', (e)=>{
          const freqMinimumQty = frequency.options[ frequency.selectedIndex ].getAttribute('data-minimum-qty');
          this.minQuantityToAdd = parseInt(freqMinimumQty)
          subscriptionBoxTitle.innerText = `${freqMinimumQty} ${subscriptionBoxTitleLabel}`
          this.updateOfferBarData(freqMinimumQty);
          this.handleMinQuantityToAdd(checkedInput, this.minQuantityToAdd)
        })
      }

      updateOfferBarData(newMinimumQty){
        const offerBar = document.querySelector('offer-bar');
        const progress = offerBar.querySelector('[data-progress]')
        const offerBarMessage = document.querySelector('.offer-block__message')

        // Update Offer Bar Target
        offerBar.setAttribute('data-target', parseInt(newMinimumQty))

        // Get the total selected QTYs and make a calculation get the Progress
        var QTYs = document.querySelectorAll('.option_variant .quantity__input')
        var total = 0
        QTYs.forEach(QTY => {total = total + parseInt(QTY.value)});
        const progressPercentage = (total / this.minQuantityToAdd) * 100.0

        /*
          Calculate the remaining number to reach the target
          Assign the right messages
        */
        const remainNumber = this.minQuantityToAdd - total
        var message = offerBar.getAttribute('data-message').replace("$", remainNumber);
        var congratsMessage = offerBar.getAttribute('data-congrats-message')

        /* 
          Set the Right Progress & Message
        */
        setTimeout(() => {
          progress.style.width = `${progressPercentage}%`
          if (progressPercentage < 100) {
            offerBarMessage.innerText = message
          }else{
            offerBarMessage.innerText = congratsMessage
          }
        }, 500);
      }
    }
  );
}
